import React, { useState } from "react";
import { Button, CircularProgress, InputLabel, TextField, Typography } from "@mui/material";
import { useMutation } from 'react-query'
import { editProductMinimumRecoveryValue } from "services/api/Product";
import FlexibleWidthDialog from "components/Dialog/FlexibleWidthDialog"
import { NumericFormat } from 'react-number-format';
import PropTypes from 'prop-types';

const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(props, ref) {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      valueIsNumericString
      prefix="$"
    />
  );
});

NumberFormatCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default function MinimumRecoveryValue({ open, close, reportAction, instance }) {
  const [isLoading, setIsLoading] = useState(false)
  const [values, setValues] = useState({
    minimum_recovery_value: '',
    confirm_minimum_recovery_value: ''
  });

  const mutation = useMutation(editProductMinimumRecoveryValue, {
    onSuccess: (data) => {
      setIsLoading(false)
      if(data.status === "error") { reportAction(false, 'Error al guardar los datos', "error")
      } else { reportAction(true, 'Datos guardados correctamente', "success") }
    }
  })

  const handleEdit = () => { 
    setIsLoading(true)
    mutation.mutate({ id: instance._id, params: { minimum_recovery_value: values.minimum_recovery_value } })
  }
  
  const handleClose = () => { setValues({ minimum_recovery_value: '0', confirm_minimum_recovery_value: '0' }); close() }

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const Actions = () => (<>
    { !isLoading ? <>
      <Button onClick={handleClose}>Cancelar</Button>
      <Button variant="contained" color="info" onClick={handleEdit} disabled={values.minimum_recovery_value !== values.confirm_minimum_recovery_value || values.minimum_recovery_value === "0" || values.minimum_recovery_value === ""}>Editar</Button>
      </> : <CircularProgress /> }
  </>)

  return (<>
    <FlexibleWidthDialog open={ open } title={ `Valor mínimo de recuperación - ${instance.name}` } actions={ <Actions /> }>
      <Typography variant="h5">Valor actual: ${instance.minimum_recovery_value.toLocaleString("es-MX")}</Typography><br/>
      <InputLabel htmlFor='formatted-minimum_recovery_value' style={{ fontSize: 18 }}>Valor</InputLabel>
      <TextField
        value={values.minimum_recovery_value}
        fullWidth
        autoFocus
        size="small"
        onChange={handleChange}
        name="minimum_recovery_value"
        id="formatted-minimum_recovery_value-input"
        inputProps={{style: { textAlign: 'center' }}}
        InputProps={{
          sx:{ fontSize: 30 },
          inputComponent: NumberFormatCustom,
        }}
        variant="outlined"
      />
      <br /><br />
      <InputLabel htmlFor='formatted-confrim-minimum_recovery_value' style={{ fontSize: 18 }}>Confirmar valor</InputLabel>
      <TextField
        value={values.confirm_minimum_recovery_value}
        fullWidth
        size="small"
        onChange={handleChange}
        name="confirm_minimum_recovery_value"
        id="formatted-confrim-minimum_recovery_value"
        inputProps={{style: { textAlign: 'center' }}}
        InputProps={{
          sx:{ fontSize: 30 },
          inputComponent: NumberFormatCustom,
        }}
        variant="outlined"
      />
      <br /><br />
      {values.minimum_recovery_value !== values.confirm_minimum_recovery_value ?  
      <Typography>Ambos campos deben contener el mismo monto para poder editar el valor</Typography> : null}

    </FlexibleWidthDialog>
  </>)
}